module.exports = __webpack_public_path__ + "static/media/stress-intro.c77f6954.svg";